import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";
import { numberFormatter } from "@common/helpers/number";
import { useMemo } from "react";
import { pluralize } from "@common/helpers/string";
import { useBulkActions } from "../useBulkActions";

interface RemoveCounterpartyConfirmationModalProps {
    show: boolean;
    onHide: () => void;
    onConfirm: () => Promise<void>;
}

export const RemoveCounterpartyConfirmationModal: React.FC<
    RemoveCounterpartyConfirmationModalProps
> = ({ show, onHide, onConfirm }) => {
    const bulkActions = useBulkActions();

    const transactionsWithCounterpartyId = useMemo(
        () =>
            bulkActions.selectedArray.filter(
                (transaction) => transaction.counterpartyId,
            ),
        [bulkActions.selectedArray],
    );

    const selectedCount = bulkActions.selectedCount;

    const haveOrHas =
        transactionsWithCounterpartyId.length > 1 ? "have" : "has";
    const themOrIt = transactionsWithCounterpartyId.length > 1 ? "them" : "it";
    const assignmentPlural = pluralize(
        "assignment",
        transactionsWithCounterpartyId.length,
    );
    const title = `Remove counterparty for ${numberFormatter.format(transactionsWithCounterpartyId.length)} ${pluralize("transaction", transactionsWithCounterpartyId.length)}`;

    const allSelectedText =
        selectedCount === 1
            ? "the selected transaction"
            : "all selected transactions";

    const question =
        transactionsWithCounterpartyId.length === selectedCount
            ? `Are you sure you want to remove the counterparty ${assignmentPlural} for ${allSelectedText}?`
            : `${numberFormatter.format(transactionsWithCounterpartyId.length)} of ${numberFormatter.format(selectedCount)} selected transactions ${haveOrHas} a counterparty assigned. Do you want to remove ${themOrIt}?`;

    return (
        <ConfirmationModal
            show={show}
            onHide={onHide}
            onReject={onHide}
            onConfirm={onConfirm}
            title={title}
            question={question}
            yes="Remove"
            yesBtnVariant="primary"
        />
    );
};
